import { memoizeFunction, mergeStyleSets } from '@ms/yammer-web-core-ui/dist/util/styling';

export const getClassNames = memoizeFunction((isAppRTL) =>
  mergeStyleSets({
    container: {
      height: 48,
    },
    contentWrapper: {
      height: '100%',
    },
    internalLink: {
      display: 'flex',
      alignItems: 'center',
      height: '100%',
    },
    notificationsItem: {
      zIndex: isAppRTL ? 1 : 2,
    },
    inboxItem: {
      zIndex: isAppRTL ? 2 : 1,
    },
    moreActionsItem: {
      zIndex: 0,
    },
  })
);
